export enum RecordingState {
  stop = 'stop',
  pending = 'pending',
  recording = 'recording'
}
